export default __webpack_public_path__ + "static/media/metal_highlight_blur.f8996d5b.png";